var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],attrs:{"id":"loading"}},[_c('Spinner',{attrs:{"size":"large","line-fg-color":_vm.fgcolor}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }